import httpClient from "./httpClient";

const PAYMENT_PATH = '/shopping-cart'
/**
 *
 * @param token : API Access Token
 * @param current_page: target page for submit answers
 * @param answers: List of UserAnswer Object
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
function getPaymentStatus(token, quiz_id) {

    // construct payload to submit an answer to api end points
    return httpClient.get(token, PAYMENT_PATH + '/status?quiz='+quiz_id);
}



export default {getPaymentStatus};